import React, {
    useState,
    useRef,
    forwardRef,
    useImperativeHandle,
    useEffect,
} from 'react'
import { DocumentEditor } from '@onlyoffice/document-editor-react'
import { saveFile } from '../../utils/utils'
import save from '../../icons/Save.svg'
import { useAuthInfo } from '@propelauth/react'
import { Box, Container, Skeleton } from '@mui/material'
import { v4 as uuidv4 } from 'uuid'
import { getJWTToken } from '../../utils/utils'
import { findKeyByArrayValue } from '../../utils/utils'
import { onlyOfficeDocumentTypes } from '../../utils/OnlyOfficeDocumentTypes'

// const OnlyOfficeViewerComponent = forwardRef(({ initialFile, userId }, ref) => {
const OnlyOfficeViewerComponent = ({
    documentId="docxEditor",
    fileType="docx",
    initialFile,
    onLoaded,
    documentName,
    documentKey,
    displayType = 'embedded',
    integrationMode = 'embed',
    documentType = null,
    editorInstance,
    setEditorInstance,
    readOnly = false
}) => {
    // console.log('documentTypes', onlyOfficeDocumentTypes)
    console.log('Initial File', initialFile)
    console.log('Document ID (for callback URL):', documentId)
    console.log('Document Key (for OnlyOffice versioning):', documentKey)
    console.log('Document Name', documentName)
    // Constants
    const API_BASE_URL = process.env.REACT_APP_API_URL_BASE
    
    // Use production backend for OnlyOffice callbacks if running locally
    const ONLYOFFICE_BASE_URL = (API_BASE_URL?.includes('localhost:8000') || API_BASE_URL?.includes('127.0.0.1:8000'))
        ? 'https://backend.artosai.com'
        : API_BASE_URL


    console.log('ONLYOFFICE_BASE_URL', ONLYOFFICE_BASE_URL)

    // Callback URL uses the actual documentId (not the versioned key)
    const CALLBACK_URL = `${ONLYOFFICE_BASE_URL}/save-document?documentName=${documentName}&documentId=${documentId}`
    console.log('Callback URL:', CALLBACK_URL)
    // const ONLYOFFICE_CALLBACK_URL = process.env.REACT_APP_API_CALLBACK_URL
    // const DEMO_CALLBACK_URL = `https://backend.artosai.com/demo-save-document?documentName=${documentName}`

    if (!documentType) {
        documentType = findKeyByArrayValue(onlyOfficeDocumentTypes, fileType) || 'word'
    }

    console.log('documentType', documentType)

    const [isLoading, setIsLoading] = useState(true)
    const [URL, setURL] = useState(true)

    const authInfo = useAuthInfo()

    // Get user info for collaborative editing
    const userInfo = authInfo?.user
    const userId = userInfo?.userId || 'anonymous'
    const userName = userInfo?.firstName && userInfo?.lastName
        ? `${userInfo.firstName} ${userInfo.lastName}`
        : userInfo?.email || 'Anonymous User'

    const truncatedDocumentName = () => {
        if (!documentName) return 'Untitled Document'
        const parts = documentName.split('/')
        return parts[parts.length - 1] || documentName
    }

    const getOrgAccessToken = async (orgId) => {
        return await authInfo.tokens.getAccessTokenForOrg(orgId)
    }

    function onLoadComponentError(errorCode, errorDescription) {
        console.error('OnlyOffice Load Error:', {
            errorCode,
            errorDescription,
            documentKey,
            documentName,
            initialFile,
            documentId
        })
        
        // Provide user-friendly error messages
        switch(errorCode) {
            case -1:
                console.error('Unknown error loading OnlyOffice component')
                break
            case -2:
                console.error('Error loading DocAPI from document server')
                break
            case -3:
                console.error('DocAPI is not defined')
                break
            default:
                console.error('Unexpected error code:', errorCode)
        }
    }

    useEffect(() => {
        setURL(initialFile)
        setIsLoading(false)
    }, [])

    // Use documentKey (versioned) as the OnlyOffice key for collaborative editing
    const key = documentKey
    console.log('OnlyOffice key (versioned):', key)

    // useEffect(() => {
        // console.log('url', initialFile)
        // const fetchToken = async () => {
            // try {
                // const payload = {
                //     document: {
                //         fileType: 'docx',
                //         key: documentId,
                //         title: truncatedDocumentName,
                //         url: initialFile,
                //     },
                //     documentType: 'word',
                //     editorConfig: {
                //         callbackUrl: CALLBACK_URL,
                //     },
                // }

                // const orgAccessToken = await getOrgAccessToken() // Assume this function is defined elsewhere
                // const data = await getJWTToken(orgAccessToken, payload); // bring this back in later
                // setToken(data.token);
            // } catch (error) {
                // console.error('Error fetching JWT:', error)
            // }
        // }

        // if (initialFile) {
            // fetchToken()
        // }
    // }, [initialFile])

    // function onDocumentReady(event) {
    //     console.log(event)
    //     console.log('Document is loaded')
    // }

    var connector = ''

    // var onDocumentReady = function (event) {
    //     try {
    //         // Check if DocEditor and the specific instance exist before accessing
    //         if (
    //             window.DocEditor &&
    //             window.DocEditor.instances &&
    //             window.DocEditor.instances[documentId]
    //         ) {
    //             var docEditor = window.DocEditor.instances[documentId]

    //             // Only create connector if the method exists
    //             if (
    //                 docEditor &&
    //                 typeof docEditor.createConnector === 'function'
    //             ) {
    //                 connector = docEditor.createConnector()
    //                 console.log(
    //                     'Document editor connector created successfully'
    //                 )

    //                 // Only try to execute method if connector was created
    //                 if (
    //                     connector &&
    //                     typeof connector.executeMethod === 'function'
    //                 ) {
    //                     try {
    //                         connector.executeMethod(
    //                             'GetSelectedText',
    //                             [],
    //                             function (selectedText) {
    //                                 console.log('Selected Text: ', selectedText)
    //                             }
    //                         )
    //                     } catch (methodError) {
    //                         console.log('Error executing method: ', methodError)
    //                     }
    //                 } else {
    //                     console.log('Connector or executeMethod not available')
    //                 }
    //             } else {
    //                 console.log('createConnector method not available')
    //             }
    //         } else {
    //             console.log('DocEditor instances not initialized yet')
    //         }

    //         // Always call onLoaded regardless of connector status
    //         onLoaded()
    //     } catch (error) {
    //         console.log('Error in document ready handler: ', error)
    //         // Still call onLoaded even if there was an error
    //         onLoaded()
    //     }
    // }

    const onDocumentReady = (event) => {
        console.log('Document ready event: ', event)
        setEditorInstance(window.DocEditor.instances[documentId])
        console.log('editorInstance', editorInstance)
        console.log('Document editor ready.')
    }

    const SkeletonLoader = () => (
        <Container maxWidth="md">
            <Box mb={4}>
                <Skeleton variant="rectangular" width="100%" height={60} />
            </Box>
            {[...Array(4)].map((_, index) => (
                <Box key={index} mb={4}>
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="95%" height={20} />
                    <Skeleton variant="text" width="98%" height={20} />
                    <Skeleton variant="text" width="92%" height={20} />
                </Box>
            ))}
            <Box mt={6}>
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Box>
        </Container>
    )

    return (
        <div
            className="OnlyOfficeComponent"
            style={{ height: '100%', position: 'relative' }}
        >
            {isLoading && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1000,
                        backgroundColor: 'white',
                    }}
                >
                    <SkeletonLoader />
                </div>
            )}
            {/* <UpdatedEditor /> */}

            {initialFile && !isLoading && typeof URL === 'string' && documentKey && (
                <DocumentEditor
                    id={documentId}
                    documentServerUrl={process.env.REACT_APP_ONLYOFFICE_SERVER_URL}
                    config={{
                        document: {
                            fileType: fileType,
                            key: key,
                            title: truncatedDocumentName(),
                            url: initialFile,
                            permissions: {
                                edit: !readOnly,
                                review: !readOnly,
                            }
                        },
                        documentType: documentType,
                        type: displayType,
                        editorConfig: {
                            callbackUrl: CALLBACK_URL,
                            coEditing: {
                                mode: "fast",
                                change: true,
                            },
                            user: {
                                id: userId,
                                name: userName,
                            },
                            customization: {
                                uiTheme: 'theme-light',
                                compactHeader: true,
                                integrationMode: integrationMode,
                                macros: true,
                                macrosMode: 'enabled',
                                zoom: 80,
                                forcesave: true,

                            },
                            // callbackUrl: CALLBACK_URL,
                            // callbackUrl: ONLYOFFICE_CALLBACK_URL,
                            // callbackUrl: DEMO_CALLBACK_URL,
                        },
                        events: {
                            onDocumentReady: onDocumentReady,
                            onLoadComponentError: onLoadComponentError
                        }
                        // "token": token,
                    }}
                    // events_onDocumentReady={onDocumentReady}
                    // events_onDocumentStateChange={onDocumentChanged}
                    // onLoadComponentError={onLoadComponentError}
                />
            )}
        </div>
    )
}

export default OnlyOfficeViewerComponent
